export default "/static/ixm_tiny.png";